
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/dx",
      function () {
        return require("private-next-pages/services/dx.tsx");
      }
    ]);
  